<template>
  <div>
    <div v-scroll-reveal.reset class="text-center mt-8 mb-16" dir="auto">

      <h2  class="font-weight-bold secondary--text">
        {{$t('emblem')}}{{$t('emblem-o')}}
      </h2>
    </div>
  <v-row class="my-16">
    <v-col v-for="item in glass_quality_hints" cols="12" xl="3" lg="3" md="3" class="text-center d-flex justify-center align-start">
      <div class="test d-flex flex-column justify-center align-center mx-6">
        <v-img class="mb-4" contain height="100" width="120" :src="item.file"></v-img>
<!--        <v-icon size="90" color="#FCC300" class="mb-4">{{item.file}}</v-icon>-->
        <h4 class="font-weight-bold secondary--text">{{item.title}}</h4>
      </div>
    </v-col>
  </v-row>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'mainGlassHint',
  computed: {
    ...mapState({
      glass_quality_hints: state => state.glassManagement.glass_quality_hints,
    })
  },
  data(){
    return{
      hint:[
        {
          image:'https://ardakanglass.com/uploads/banners/16314573043913.PNG',
          title:'بزرگترین خط تولید شیشه فلوت در خاورمیانه',
        },
        {
          image:'https://ardakanglass.com/uploads/banners/16314573043913.PNG',
          title:'کامل ترین کارخانه تولید و پروسسینگ شیشه در غرب آسیا'
        },
        {
          image:'https://ardakanglass.com/uploads/banners/16314573043913.PNG',
          title:'ارائه سبذ کاملی از محصولات شیشه تخت',
        },
        {
          image:'https://ardakanglass.com/uploads/banners/16314573043913.PNG',
          title:'صادرکننده برتر کشوری، واحد نمونه صنعتی و کارآفرین برتر ملی ',
        },
      ]

    }
  },
  created() {
    this.$store.dispatch('glassManagement/getGlassQualityHints');
  },
}
</script>
<style scoped>
.test{
  position: relative;
  animation-name: examples;
  animation-duration: 3s;
  animation-fill-mode: forwards;
}
@keyframes examples {
  from {top: 300px;}
  to {top:0;}
}
</style>